import { amountSign } from "./ledgerFormat";

// What a debit (positive) and a credit (negative) leg means on each ledger account.
const EFFECTS: Record<string, [debit: string, credit: string]> = {
  COMPANY_BALANCE: ["Company owes Soldera more", "Soldera owes company more"],
  GO_PURCHASE_COST: ["GO purchase cost recorded", "GO purchase cost reduced"],
  GO_SALES_REVENUE: ["Sales revenue reduced", "Sales revenue recorded"],
  FEE_REVENUE: ["Fee revenue reduced", "Fee revenue recorded"],
  REGISTRY_COST: [
    "Registry cost recharge undone",
    "Registry cost recharged to company",
  ],
  REFERRAL_EXPENSE: ["Referral expense recorded", "Referral expense reduced"],
  VAT_CLEARING: ["Output VAT reduced or input VAT", "Output VAT charged"],
  VAT_PAYABLE: ["VAT payable reduced", "VAT payable increased"],
  CASH: ["Cash received", "Cash paid out"],
  OPENING_EQUITY: [
    "Pre-ledger amount owed to company",
    "Pre-ledger amount owed to Soldera",
  ],
  ROUNDING_DIFFERENCE: ["Rounding loss", "Rounding gain"],
  FX_CLEARING: ["Conversion in", "Conversion out"],
  FX_RESULT: ["FX loss", "FX gain"],
};

/** The plain-language effect of one entry line, or "" for an account without copy. */
export function lineEffect(account: string, amount: string): string {
  const effect = EFFECTS[account];
  if (!effect) return "";
  return amountSign(amount) > 0 ? effect[0] : effect[1];
}
